import React from "react";
import { useTranslation } from "react-i18next";

import AddCompanyInfo from "../AddCompanyInfo";
import EmployeeAutoComplete from "components/InputsField/formikInputs/EmployeeAutoComplete";
import FormRow from "components/common/Layout/FormRow";
import { EMPLOYEE } from "endpointsConst";

const AddCompanyInfoWithEmployee = ({ children }) => {
    const { t } = useTranslation();

    return (
        <AddCompanyInfo
            additionalFields={
                <>
                    <FormRow withMargin>
                        <EmployeeAutoComplete
                            url={`${EMPLOYEE}/search`}
                            noOptionsMessage={t("addContact.noEmployee")}
                            name="employee_ids"
                            label={t("addContact.employee")}
                            isMulti
                        />
                        <></>
                    </FormRow>
                    {children}
                </>
            }
        />
    );
};

export default AddCompanyInfoWithEmployee;
